const actionDict = {
  10: 'Установка',
  11: 'Удаление',
};

export const action = (val) => actionDict[val];
